export default __webpack_public_path__ + "static/media/typewriter.f771ce55.jpg";